import { ReactComponent as IconArrowDown } from '@/assets/svgs/chevron-down-small.svg';
import { ReactComponent as IconDataElement } from '@/assets/svgs/data-element-grey.svg';
import { ReactComponent as IconDocument } from '@/assets/svgs/document-grey.svg';
import { ReactComponent as IconPackage } from "@/assets/svgs/icon-eclip-package-card.svg";
import { ReactComponent as IconNoMessage } from '@/assets/svgs/no-message.svg';
import { ReactComponent as IconPinToTop } from "@/assets/svgs/pin-solid-small.svg";
import MultiLevelDropDown from "@/components/MultiLevelMenuDropDown/index.js";
import { ToastContext } from '@/context/toast/index.js';
import useModal from '@/hooks/use-modal/index';
import packageApi from "@/services/api/packages.js";
import getDateTime from "@/utils/get-date-time.js";
import { useContext, useState } from 'react';
import MultiClamp from 'react-multi-clamp';
import { useNavigate } from '@/lib/router-dom';
import MovePackageToFolderModal from "./move-package-to-folder-modal.jsx";
import StatusBadge from './package-status-badge.jsx';
import { BADGE_STATUS } from '../utils/get-package-status.js';
import CheckboxButton from '@/components/CheckboxButton'
import PropTypes from 'prop-types';

function filterButton() {
	return (
		<span className="package-data-table__ref-id-filter">
			<IconArrowDown />
		</span>
	)
}

export default function PackageDataTable({
	items,
	setSortConfig,
	sortConfig,
	refreshData,
	setRefreshData,
	folderId,
	isVeridaptFolder = false,
	folderName = "",
	selectedPackages,
	setSelectedPackagesInFolder,
	showCheckBox,
	handleAllCheckBoxPackages
}) {

	/*=================================================/
		General
	/================================================*/

	const { goTo } = useNavigate();
	const { addToastMessage } = useContext(ToastContext)


	const [showPackageRef, setShowPackageRef] = useState(true);
	const [showMyOwnRef, setShowMyOwnRef] = useState(false);


	/*=================================================/
		Hooks
	/================================================*/
	const {
		visible: isShowMovePackageToFolderModal,
		hide: hideMovePackageToFolderModel,
	} = useModal();


	/*=================================================/
		Functions
	/================================================*/
	function getClassName(name) {
		if (!sortConfig) {
			return
		}

		if (sortConfig.key === name) {
			return sortConfig.direction === true ? "is-asc" : "is-desc"
		}

		return ""
	}

	function handleSort(key) {
		let direction = sortConfig.direction
		if (sortConfig.key === key) {
			direction = !direction
		} else {
			direction = true
		}

		setSortConfig({ key, direction })
	}

	const goToPackageDetail = (item) => {
		if (item?.badge === BADGE_STATUS.receiving) {
			addToastMessage("Receiving package in process", "error");
			return;
		}

		if (item?.badge === BADGE_STATUS.receiveFailed) {
			addToastMessage("Package failed to receive", "error");
			return;
		}

		if (item?.badge === 'PACKAGE_DECLINED' && item?.request) {
			addToastMessage('Package Declined', 'error')
			return;
		}
		if (item?.badge === 'PACKAGE_ACCEPTED') {
			if (item?.type === "RECEIVE") {
				addToastMessage('No data available yet', 'error')
				return;
			}
		}
		if (item?.badge === 'PACKAGE_REQUESTED') {
			if (item?.type === "RECEIVE") {
				addToastMessage('Receipient has not responded yet', 'error')
				return;
			}
			goTo(`/eclip/respond/${item.id}`)
			return;
		}

		goTo(`/package/details/${item.id}`, { folderName: folderName });
	}

	const handlePin = async (item) => {
		const [error] = await packageApi.pinPackage(item.pinned ? "unpin" : "pin", {
			eclipId: item.id
		});

		if (error) {
			return addToastMessage(item.pinned ? "Pin not removed" : "Pin not added", 'error')
		}

		setRefreshData(!refreshData)

		addToastMessage(
			item.pinned ? "Removed pin successfully" : "Pinned successfully",
			"success"
		);
	};

	const list = items?.map((item) => {
		const participantsList = item.participants ?? []
		const participantHoverName = participantsList.slice(0, 5)

		return (
			<>
				<div className={selectedPackages?.findIndex((selection) => selection === item.id) !== -1 ? "data-table__table__body__row__selected" : "data-table__table__body__row"} key={item.id}>
					<div className="package-data-table__contents-col">
						<div className="package-data-table package-data-table__pin">
							{item.pinned && <IconPinToTop />}
						</div>

						<div className="package-data-table package-data-table__package-name">
							<div className="package-data-table__package-info">
								<div className='package-data-table__package-info__padding'>
									{(showCheckBox) ?
										<CheckboxButton
											check={selectedPackages?.findIndex((selection) => selection === item.id) !== -1}
											onChange={() => setSelectedPackagesInFolder(item.id)}
											value={item.id}
										/> : <div className="package-card__icon icon--non-veridapt">
											<IconPackage />
										</div>
									}
								</div>
								<div className="package-data-table__package-name-stat" onClick={() => goToPackageDetail(item)} onKeyDown={() => goToPackageDetail(item)} data-testid="package-item">
									<div className="heavy-text tooltip">
										<MultiClamp clamp={1}>{item.name}</MultiClamp>
										<span className={"tooltiptext__package-folder-name"}>
											{item.name}
										</span>
									</div>
									<div className="package-data-table__package-stat ">
										<div className="package-card__data-element-info tooltip">
											<IconDataElement />
											<span>{String(item?.dataElementsCount).padStart(2, "0")}</span>
											<span className="tooltiptext__package-landing">
												Data element
											</span>
										</div>
										<div className="package-card__attachment-info tooltip">
											<IconDocument />
											<span>{String(item?.attachmentsCount).padStart(2, "0")}</span>
											<span className="tooltiptext__package-landing">
												Attachment
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="package-data-table color-text package-data-table__package-ref" onClick={() => goToPackageDetail(item)} onKeyDown={() => goToPackageDetail(item)} data-testid="package-item-reference">
							{item.type === "SEND" && (showPackageRef || showMyOwnRef) && item.referenceNumber}
							{item.type === "RECEIVE" && showPackageRef && item.receivedReferenceNumber}
							{item.type === "RECEIVE" && showMyOwnRef && item.referenceNumber}
						</div>

						<div
							className="package-data-table color-text tooltip package-data-table__participant participant-text-aligment--center"
							onClick={() => goToPackageDetail(item)}
							onKeyDown={() => goToPackageDetail(item)}
							data-testid="package-item-participants"
						>
							<div>
								{participantsList?.length > 0 ? (<div><MultiClamp clamp={1}>{participantsList[0]?.name}</MultiClamp></div>) : (<div>No participant</div>)}
								{participantsList?.length > 1 && (
									<div className="pacakge-data-table__participant-count-text">{`...+${participantsList?.length - 1} more`}</div>
								)}
								<span className={participantsList?.length > 0 ? "tooltiptext__package-table-participant-name" : ''}>
									{participantHoverName?.map((participant) => <div key={participant.id}>{participant.name}</div>)}
									{participantsList?.length > 5 && <div className="package-card__participant-count__tooltip-text">{`...+${participantsList.length - 5} more`}</div>}
								</span>
							</div>
						</div>

						<div className="package-data-table package-data-table__status" onClick={() => goToPackageDetail(item)} onKeyDown={() => goToPackageDetail(item)} data-testid="package-item-badge">
							<StatusBadge badge={item?.badge} />
						</div>

						<div className="package-data-table color-text heavy-text flex-item package-data-table__date" onClick={() => goToPackageDetail(item)} onKeyDown={() => goToPackageDetail(item)}>
							<div className="package__modified-date">{getDateTime(item.modified)}</div>
						</div>
					</div>

					<div className="package-data-table__menu-col">
						<div className="package-data-table package-data-table__menu" data-testid="side-menu">
							{item.isVeridapt && (
								<MultiLevelDropDown
									menuList={
										[
											{
												label: item.pinned ? "Unpin" : "Pin",
												onClick: (e) => {
													e.stopPropagation();
													handlePin(item);
												},
											}
										]
									}
									placement={"bottom-start"}
								/>

							)}
							{!item.isVeridapt && (
								<MultiLevelDropDown
									menuList={[
										// folderId ? {
										// 	label: "Move to ...",
										// 	submenu: [
										// 		// {
										// 		// 	label: "Package Sharing",
										// 		// 	icon: <IconFolderArrowUp />,
										// 		// 	onClick: (e) => {
										// 		// 		e.stopPropagation();
										// 		// 		movePackage(item)
										// 		// 	},
										// 		// },
										// 		{
										// 			label: "Folders",
										// 			icon: <IconFolder />,
										// 			onClick: (e) => {
										// 				e.stopPropagation();
										// 				setSelectedItem(item);
										// 				showMovePackageToFolderModal();
										// 			}
										// 		}
										// 	],
										// } : {
										// 	label: "Move to Folder",
										// 	onClick: (e) => {
										// 		e.stopPropagation();
										// 		setSelectedItem(item);
										// 		showMovePackageToFolderModal();
										// 	}
										// },
										{
											label: item.pinned ? "Unpin" : "Pin",
											onClick: (e) => {
												e.stopPropagation();
												handlePin(item);
											},
										},
										// (item?.type === "RECEIVE" && item.badge !== 'PACKAGE_DECLINED') && !item.request ? {
										// 	label: "Decline",
										// 	onClick: (e) => {
										// 		e.stopPropagation();
										// 		setSelectedItem(item);
										// 		showConfirmDeclineModal();
										// 	},
										// } : undefined,
									]}
									placement={"bottom-start"}
								/>
							)}
						</div>
					</div>
				</div>
			</>
		)
	})

	return (
		<>
			<div className="data-table__content eclip-data-table">
				<div className="data-table__content__cols">
					<div className="data-table__content__col">
						<div className="data-table__table data-table__table__margin-top">
							<div className="data-table__table__head">
								<div className="data-table__table__head__row">
									<div className="package-data-table__contents-col">

										<div className='package-data-table package-data-table__pin'></div>

										<div className={`package-data-table data-table__table__head__title__sort-order ${getClassName("name")} package-folder-table__header-text package-data-table__package-name`}
											id="name">
											{(showCheckBox) && <CheckboxButton
												check={selectedPackages?.length > 0 && selectedPackages?.length === items?.length}
												onChange={() => handleAllCheckBoxPackages()}
											/>}
											Package Name <span className="data-table__table__head__icon__sort-order" onClick={(e) => { handleSort('name') }} onKeyDown={(e) => { handleSort('name') }}></span>
										</div>

										<div className={`package-data-table package-folder-table__header-text flex-item package-data-table__package-ref`}>
											{showPackageRef ? "Package Reference ID" : "My Reference ID"}
											<MultiLevelDropDown
												button={filterButton}
												menuList={[
													{
														label: 'My Reference ID',
														onClick: (e) => {
															e.stopPropagation();
															setShowPackageRef(false)
															setShowMyOwnRef(true)
														},
													},
													{
														label: "Package Reference ID",
														onClick: (e) => {
															e.stopPropagation();
															setShowPackageRef(true)
															setShowMyOwnRef(false)
														},
													}
												]}
											/>
										</div>

										<div
											className={`package-data-table data-table__table__head__title__sort-order ${getClassName("participant")} package-folder-table__header-text package-data-table__participant`}
											id="participant"
										>
											Participants
										</div>

										<div
											className={`package-data-table data-table__table__head__title__sort-order ${getClassName("status")} package-folder-table__header-text package-data-table__status`}
											id="status"
											onClick={(e) => { handleSort('status') }}
										>
											Status <span className="data-table__table__head__icon__sort-order"></span>
										</div>

										<div
											data-testid='sort-order'
											className={`package-data-table data-table__table__head__title__sort-order ${getClassName("modified")} package-folder-table__header-text package-data-table__date`}
											id="modified"
											onClick={(e) => { handleSort('modified') }}
										>
											<span className='package__modified-date'>Last modified </span>
											<span className="data-table__table__head__icon__sort-order"></span>
										</div>
									</div>

									<div className="package-data-table__menu-col">
										<div className='package-data-table'>
											<div className='package-data-table__header-menu'></div>
										</div>
									</div>
								</div>
							</div>

							<div className="data-table__table__body">
								{list?.length > 0 ?
									list :
									<div className="data-table__empty" data-testid='empty-table'>
										<div className="data-table__empty__icon">
											<IconNoMessage />
										</div>
									</div>
								}
							</div>
						</div>
					</div>
				</div>
			</div>

			<MovePackageToFolderModal
				isVisible={isShowMovePackageToFolderModal}
				hideModal={hideMovePackageToFolderModel}
				//packageId={selectedItem.id}
			/>
		</>
	)

}

PackageDataTable.propTypes = {
	items: PropTypes.any,
	folderName: PropTypes.string,
	selectedPackages: PropTypes.any,
	setSelectedPackagesInFolder: PropTypes.func,
	handleAllCheckBoxPackages: PropTypes.func,
	showCheckBox: PropTypes.bool,
};
